import { FunctionComponent, useEffect } from "react";
import useVerifyBalance from "@form/hooks/useVerifyBalance";
import type { HoldingForm } from "@form/components/form/modules/holding";
import { useAccount as userWeb3Account } from "wagmi";
import { CheckIcon } from "@form/components/common/icons";
import useVerifyCampaign from "@form/hooks/useVerifyCampaign";
import { AvailableNetworks } from "@form/services/network";

import { Token } from "@form/types";

const TokenBalanceVerify: FunctionComponent<{
  verify: HoldingForm;
  setWalletQualified: (stat: any) => void;
  needVerify: boolean;
}> = ({ verify, setWalletQualified, needVerify }) => {
  const { address } = userWeb3Account();
  const { verifySuccess } = useVerifyBalance(
    verify.values.token as any,
    address,
    verify.values.amount
  );

  const { changeVerifyState, result } = useVerifyCampaign(`token_balance`);

  const showSignError = needVerify && !result.token_balance;

  useEffect(() => {
    changeVerifyState(verifySuccess);
    setWalletQualified(verifySuccess);
  }, [verifySuccess]);

  const chain = AvailableNetworks.find((network) => {
    return String(network.config.id) === verify.values.chain;
  });

  const desc = `Wallet has at least ${verify.values.amount} ${
    (verify.values.token as any as Token)?.name
  } on ${chain?.name} Chain`;

  return (
    <div>
      <div
        className={`mt-2 py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ${
          showSignError ? "bg-error/10 border border-error" : ""
        }`}
      >
        <div className="text-body text-dark1 dark:text-[#F9F9F9]">{desc}</div>
        <CheckIcon
          className={`${
            verifySuccess
              ? "fill-green dark:fill-dark_green"
              : "dark:fill-[#94949C]"
          }`}
        ></CheckIcon>
      </div>
      <div
        className={`text-error text-sm mt-1 ${
          showSignError && address ? "flex" : "hidden"
        }`}
      >
        This is required
      </div>
    </div>
  );
};

export default TokenBalanceVerify;
